import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import Styles from "./Header.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Image from "../../components/Image/Image";
import images from "../../assets/images/images";
import useResponsive from "../../hooks/useResponsive";
import { FaBars } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { IoMdArrowDropdown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { FaSortDown } from "react-icons/fa";
import { LogoutUser } from "../../redux/slices/auth";
import { useTranslation } from "react-i18next";
import EditUserForm from "../../sections/main/InfomationUserForm";
import { t } from "i18next";
import { CircularProgress } from "@mui/material";
import { getAllUsers } from "../../redux/slices/app";
import { updateTab } from "../../redux/slices/app";

const cx = classNames.bind(Styles);

const EditModal = ({ showEdit, onHideEdit, data, isLoadingUpdateUserData }) => {
  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (showEdit) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [showEdit]);

  useEffect(() => {
    if (data) {
      setEditData(data);
    }
  }, [data]);

  useEffect(() => {
    if (!isLoadingUpdateUserData) {
      onHideEdit();
    }
  }, [isLoadingUpdateUserData]);

  return (
    <div
      className={cx("modal", showEdit ? "show-modal" : "hidden-modal")}
      onClick={onHideEdit}
    >
      <div
        className={cx("modal-container", showEdit ? "slide-in" : "slide-out")}
        onClick={(e) => e.stopPropagation()}
      >
        <span className={cx("modal-title")}>{t("information_personal")}</span>
        {isLoadingUpdateUserData ? (
          <div className={cx("loading")}>
            <CircularProgress style={{ color: "#e91e63" }} />
          </div>
        ) : (
          <>
            <button className={cx("close-btn")} onClick={onHideEdit}>
              <IoClose className={cx("close-icon")} />
            </button>
            <EditUserForm
              onHide={onHideEdit}
              data={editData}
              isLoadingUpdateUserData={isLoadingUpdateUserData}
            />
          </>
        )}
      </div>
    </div>
  );
};

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isLoggedIn, role } = useSelector((state) => state.auth);
  const { tab, users, status, isLoadingUpdateUserData } = useSelector(
    (state) => state.app
  );

  const url = window.location.pathname;
  const lastSlash = url.lastIndexOf("/");

  const isDesktop = useResponsive("up", "md");
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isDropdownMobile, setIsDropdownMobile] = useState(false);
  const [isDropdownItemMobile, setIsDropdownItemMobile] = useState(false);
  const [isDropdownLaosMobile, setIsDropdownLaosMobile] = useState(false);
  const [isDropdownItemLaosMobile, setIsDropdownItemLaosMobile] =
    useState(false);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const { user_id } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch, status]);

  useEffect(() => {
    setSearchValue(users);
  }, [users]);

  useEffect(() => {
    const url = window.location.pathname;
    const lastSlash = url.lastIndexOf("/");
    const newTab = url.slice(lastSlash + 1, url.length);

    if (newTab && tab !== newTab) {
      dispatch(updateTab(newTab));
    }
  }, [location, dispatch, tab]);

  const handleUpdateTab = (tab) => {
    dispatch(updateTab(tab));
    navigate(`/mongolia/${tab}`);
  };

  const navigate = useNavigate();

  const handleEdit = () => {
    const selectedUser = users.find((user) => user._id === user_id);
    console.log("Selected User for Edit:", selectedUser);
    if (selectedUser) {
      setEditData(selectedUser);
      setEdit(true);
      console.log("setEdit true");
    } else {
      console.log("No user found for editing.");
    }
  };

  const toggleOpenMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };

  const toggleDropdownMobile = () => {
    setIsDropdownMobile(!isDropdownMobile);
  };

  const toggleDropdownItemMobile = (e) => {
    e.stopPropagation();
    setIsDropdownItemMobile(!isDropdownItemMobile);
  };

  const toggleDropdownLaosMobile = () => {
    setIsDropdownLaosMobile(!isDropdownLaosMobile);
  };

  const toggleDropdownItemLaosMobile = (e) => {
    e.stopPropagation();
    setIsDropdownItemLaosMobile(!isDropdownItemLaosMobile);
  };

  const handleLogout = async () => {
    try {
      await dispatch(LogoutUser());
      setTimeout(() => {
        dispatch(updateTab("home"));
        // navigate("/mongolia/home");
        // window.location.reload();
      }, 100);
    } catch (err) {
      console.log(err);
    }
  };
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  

  return (
    <div className={cx("wrapper")}>
      {isDesktop ? (
        <>
          <div className={cx("header")}>
            <div className={cx("header-btn")}>
              <Link to="https://ama.gov.mn/" className={cx("login-btn")}>
                {t("contact")}
              </Link>
            </div>
            {isLoggedIn ? (
              <div className={cx("profile")}>
                <span className={cx("profile-content")}>
                  {role}
                  <FaSortDown className={cx("profile-icon")} />
                </span>
                <ul className={cx("profile-dropdown")}>
                  <li className={cx("profile-item")} onClick={handleEdit}>
                    {t("information_personal")}
                  </li>

                  <li className={cx("profile-item")} onClick={handleLogout}>
                    {t("log_out")}
                  </li>
                </ul>
                <EditModal
                  showEdit={edit}
                  onHideEdit={() => setEdit(false)}
                  data={editData}
                  isLoadingUpdateUserData={isLoadingUpdateUserData}
                />
              </div>
            ) : (
              <div className={cx("header-btn")}>
                <Link to="/mongolia/user/login" className={cx("login-btn")}>
                  {t("login")}
                </Link>
              </div>
            )}
            <button
              className={cx("flag-btn")}
              onClick={() => changeLanguage("mn")}
            >
              <Image
                src={images.mongoFlag}
                alt={images.mongoFlag}
                className={cx("flag-img")}
              />
              MN
            </button>
            <button
              className={cx("flag-btn")}
              onClick={() => changeLanguage("en")}
            >
              <Image
                src={images.ukFlag}
                alt={images.ukFlag}
                className={cx("flag-img")}
              />
              EN
            </button>
          </div>
          <div className={cx("logo-wrapper")}>
            <span className={cx("header-text")}>{t("Mongolia Code Monitoring Digital Platform (MCMDP)")}</span>
          </div>
          <div className={cx("sublogo-wrapper")}>
            <Link to="https://ama.gov.mn/">
              <Image src={images.govLogo} alt="Logo" className={cx("sublogo-img", "oval-img")} />
            </Link>
            <Link to="https://www.unicef.org/mongolia/">
              <Image src={images.unicefLogo} alt="Logo" className={cx("sublogo-img")} />
            </Link>
          </div>
        </>
      ) : (
        <>
          <div className={cx("header-mobile")}>
            <button className={cx("nav-bar-btn")} onClick={toggleOpenMenu}>
              <FaBars className={cx("nav-bar-icon")} />
            </button>
            {isLoggedIn ? (
              <div className={cx("profile")}>
                <span className={cx("profile-content")}>
                  {role}
                  <FaSortDown className={cx("profile-icon")} />
                </span>
                <ul className={cx("profile-dropdown")}>
                  <li className={cx("profile-item")} onClick={handleEdit}>
                    {t("information_personal")}
                  </li>
                  <li className={cx("profile-item")} onClick={handleLogout}>
                    {t("log_out")}
                  </li>
                </ul>
                <EditModal
                  showEdit={edit}
                  onHideEdit={() => setEdit(false)}
                  data={editData}
                  isLoadingUpdateUserData={isLoadingUpdateUserData}
                />
              </div>
            ) : (
              <div className={cx("header-btn")}>
                <Link to="/mongolia/user/login" className={cx("login-btn")}>
                  {t("login")}
                </Link>
              </div>
            )}
          </div>
          <div className={cx("logo-mobile-wrapper")}>
            <span className={cx("header-text")}>{t("Mongolia Code Monitoring Digital Platform (MCMDP)")}</span>
            <div className={cx("sublogo-wrapper")}>
              <Link to="https://ama.gov.mn/">
                <Image src={images.govLogo} alt="Logo" className={cx("sublogo-img", "oval-img")} />
              </Link>
              <Link to="https://www.unicef.org/mongolia/">
                <Image src={images.unicefLogo} alt="Logo" className={cx("sublogo-img")} />
              </Link>
            </div>
          </div>

          <div
            className={cx("overlay", { "overlay-visible": isOpenMenu })}
            onClick={() => setIsOpenMenu(false)}
          ></div>
          <div
            className={cx("sidebar", { "open-menu": isOpenMenu })}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={cx("flag-btn-wrapper")}>
              <button
                className={cx("flag-btn-mobile")}
                onClick={() => changeLanguage("mn")}
              >
                <Image
                  src={images.mongoFlag}
                  alt={images.mongoFlag}
                  className={cx("flag-img")}
                />
                MN
              </button>
              <button
                className={cx("flag-btn-mobile")}
                onClick={() => changeLanguage("en")}
              >
                <Image
                  src={images.ukFlag}
                  alt={images.ukFlag}
                  className={cx("flag-img")}
                />
                EN
              </button>
            </div>
            <button
              className={cx("close-btn")}
              onClick={() => setIsOpenMenu(false)}
            >
              <IoClose className={cx("close-icon")} />
            </button>
            <ul className={cx("sidebar-menu")}>
              <li
                className={cx("item-mobile", tab === "" ? "active-mobile" : "")}
                onClick={() => {
                  handleUpdateTab("home");
                  toggleOpenMenu();
                }}
              >
                {t("home")}
              </li>

              {/* <li
                className={cx(
                  "item-mobile",
                  tab === "detection-mobile" ||
                    tab === "check-mobile" ||
                    tab === "violation-mobile" ||
                    tab === "nonviolation-mobile"
                    ? "active-mobile"
                    : "",
                  { "dropdown-mobile-active": isDropdownMobile }
                )}
                onClick={toggleDropdownMobile}
              >
                {t("international_code")}
                <span className={cx("dropdown-btn")}>
                  <IoMdArrowDropdown className={cx("dropdown-icon")} />
                </span> */}
              {/* <ul className={cx("dropdown-mobile-active")}> */}
              <li
                className={cx(
                  "item-mobile",
                  tab === "detection-mobile" ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("detection-mobile");
                  toggleOpenMenu();
                }}
              >
                {t("auto_detect")}
              </li>

              <li
                className={cx(
                  "item-mobile",
                  tab === "report-mobile" ||
                    tab === "submit-mobile"
                    ? "active-mobile" : ""
                )}
                onClick={() => {
                  handleUpdateTab("submit-mobile");
                  toggleOpenMenu();
                }}
              >
                {t("track_form")}
              </li>

              <li
                className={cx(
                  "item-mobile",
                  tab === "violation-mobile" ||
                    tab === "nonviolation-mobile"
                    ? "active-mobile"
                    : "",
                  { "drop-item-mobile-active": isDropdownItemMobile }
                )}
                onClick={(e) => toggleDropdownItemMobile(e)}
              >
                {t("trace_violation")}
                <div className={cx("dropdown-btn")}>
                  <IoMdArrowDropdown className={cx("dropdown-icon")} />
                </div>
                <ul className={cx("dropdown-content-mobile-item")}>
                  <li
                    className={cx(
                      "dropdown-link-mobile-item",
                      tab === "violation-mobile" ? "active-mobile" : ""
                    )}
                    onClick={() => {
                      handleUpdateTab("violation-mobile");
                      toggleOpenMenu();
                    }}
                  >
                    {t("violation_list")}
                  </li>
                  <li
                    className={cx(
                      "dropdown-link-mobile-item",
                      tab === "nonviolation-mobile" ? "active-mobile" : ""
                    )}
                    onClick={() => {
                      handleUpdateTab("nonviolation-mobile");
                      toggleOpenMenu();
                    }}
                  >
                    {t("nonviolation_list")}
                  </li>
                </ul>
              </li>
              
              <li
                className={cx(
                  "item-mobile",
                  tab === "resource-center"
                    ? "active-mobile" : ""
                )}
                onClick={() => {
                  toggleOpenMenu();
                }}
              >
                <Link
                  to={"https://www.corporateaccountabilitytool.org/mongoliaresourcepage"}
                  target="_blank">
                  {t("resource_center")}
                </Link>
              </li>
              
              {role === "OPERATOR" ? (
                <li
                  className={cx(
                    "item-mobile",
                    tab === "account-management" ? "active-mobile" : ""
                  )}
                  onClick={() => {
                    handleUpdateTab("account-management");
                    toggleOpenMenu();
                  }}
                >
                  {t("account_management")}
                </li>
              ) : (
                ""
              )}
              
              

            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
